import { prop } from 'ramda'

import { ConversationAPI, CustomerAPI, DriftAPI, MeetingsAPI } from 'api'

import { encodeQueryData } from '../../utils/helpers'

export const saveDemandbaseApiKey = (apiKey) => {
  return CustomerAPI.post('/integrations/demandbase/access_token', {
    token: apiKey,
  })
}

export const saveMadKuduApiKey = (apiKey) => {
  return CustomerAPI.post('/integrations/madkudu/access_token', {
    token: apiKey,
  })
}

export const connectMarketo = ({ munchkinId, clientId, clientSecret }) => {
  return CustomerAPI.post('/integrations/marketo/config', {
    munchkinId,
    clientId,
    clientSecret,
  })
}

export const searchForMarketoActivity = (searchTerm) => {
  return CustomerAPI.get(
    `/integrations/marketo/activities/types?search=${searchTerm}`
  ).then((response) => response.data)
}

export const getMarketoToggles = () => {
  return CustomerAPI.get('/integrations/marketo/toggles').then(
    (response) => response.data
  )
}

export const patchMarketoToggles = (data) => {
  return CustomerAPI.patch('/integrations/marketo/toggles', data).then(
    (response) => response.data
  )
}

export const setMarketoLeadOwnerField = (leadOwnerField) => {
  return CustomerAPI.patch('/marketo/owner/field', { leadOwnerField }).then(
    (response) => response.data
  )
}

export const getMarketoLeadOwnerField = () => {
  return CustomerAPI.get('/marketo/owner/field')
    .then((response) => response.data)
    .then(prop('leadOwnerField'))
}

export const getHubspotToggles = () => {
  return CustomerAPI.get('/integrations/hubspot/toggles').then(
    (response) => response.data
  )
}
export const patchSlackNotificationToggle = (data) => {
  return CustomerAPI.patch('/integrations/slack/notifications', data).then(
    (response) => response.data
  )
}

export const getSlackNotificationToggle = () => {
  return CustomerAPI.get('/integrations/slack/notifications').then(
    (response) => response.data
  )
}

export const patchHubspotToggles = (data) => {
  return CustomerAPI.patch('/integrations/hubspot/toggles', data).then(
    (response) => response.data
  )
}

export const fetchMarketoMappedActivities = () => {
  return CustomerAPI.get('/integrations/marketo/activities/mapped').then(
    (response) => response.data
  )
}

export const deleteMarketoMappedActivity = (activityType) => {
  return CustomerAPI.delete(
    `/integrations/marketo/activities/mapped?activity-type=${activityType}`
  ).then((response) => response.data)
}

export const patchMarketoMappedActivities = (activities) => {
  return CustomerAPI.patch(
    '/integrations/marketo/activities/mapped',
    activities
  )
}

export const toggleLinkedinIntegration = (isEnabled) => {
  return CustomerAPI.patch('/integrations/linkedin/toggles', {
    enabled: isEnabled,
  })
}

export const toggleZoomMeetingsIntegration = (body) => {
  return CustomerAPI.patch('/integrations/zoom_meetings/toggles', body)
}

export const getZoomMeetingsEnabled = () => {
  return CustomerAPI.get('/integrations/zoom_meetings/toggles').then(
    (response) => response.data
  )
}

export const toggleGoogleMeetIntegration = (body) => {
  return CustomerAPI.patch('/integrations/googleMeet/toggles', body)
}
export const toggleMicrosoftTeamsIntegration = (body) => {
  return CustomerAPI.patch('/integrations/microsoftTeams/toggles', body)
}

export const getGoogleMeetEnabled = () => {
  return CustomerAPI.get('/integrations/googleMeet/toggles').then(
    (response) => response.data
  )
}
export const getMicrosoftTeamsEnabled = () => {
  return CustomerAPI.get('/integrations/microsoftTeams/toggles').then(
    (response) => response.data
  )
}

export const toggleVidyardIntegration = (isEnabled) => {
  return CustomerAPI.patch('/integrations/vidyard/toggles', {
    enabled: isEnabled,
  })
}

export const fetchInstalledApps = () => {
  return CustomerAPI.get('/integrations/external')
    .then((res) => res.data)
    .then((data) => data.integrations)
}

export const postIntegrationSuggestion = (suggestion) => {
  return CustomerAPI.post(`/integrationsuggestions?suggestion=${suggestion}`)
}

export const uninstallInstalledApp = (id) => {
  return CustomerAPI.post(`/integrations/external/${id}/uninstall`).then(
    (response) => response.data
  )
}

export const fetchApp = (id) => {
  return CustomerAPI.get(`/integrations/external/${id}`).then(
    (response) => response.data
  )
}

export const fetchAppScopes = (id) => {
  return CustomerAPI.get(`/integrations/external/${id}/scopes`)
    .then((response) => response.data)
    .then((data) => data.scopes)
}

export const authorizeApp = (id) => {
  return CustomerAPI.post(`/integrations/external/${id}/authorize`).then(
    (response) => response.data
  )
}

export const getGoogleScopes = () => {
  return MeetingsAPI.get('/google/calendar/oauth/scopes').then(
    (response) => response.data
  )
}

export const googleCalendarOauthAccept = (oauthCode) => {
  return MeetingsAPI.post('/google/calendar/oauth/accept', {
    code: oauthCode,
  }).then((response) => response.data)
}

export const microsoftCalendarOauthAccept = (oauthCode) =>
  MeetingsAPI.post('/microsoft/calendar/oauth/accept', {
    code: oauthCode,
  }).then((response) => response.data)

export const microsoftAdminCalendarAccept = (tenant) =>
  MeetingsAPI.post(
    '/microsoft/organization/calendar/oauth/accept',
    tenant
  ).then((response) => response.data)

export const zoomOauthAccept = (oauthCode) =>
  MeetingsAPI.post('/zoom/oauth/accept', { code: oauthCode }).then(
    (response) => response.data
  )

export const getIntegrationStates = () => {
  return CustomerAPI.get('/integrations/all/public').then((res) => res.data)
}

export const emailBusinessCsvExport = (payload) => {
  return DriftAPI.post('/business/events/export/csv', payload).then(
    (response) => response.data
  )
}

export const fetchClearbitApiKeyOwner = () => {
  return CustomerAPI.get(
    '/integrations/clearbit/properties/reveal_api_key/owner'
  ).then((response) => response.data)
}

export const fetchFacebookSettings = () =>
  CustomerAPI.get('/integrations/facebook_analytics').then(
    (response) => response.data
  )

export const fetchStripeKeys = () =>
  CustomerAPI.get('/integrations/stripe/keys').then((response) => response.data)

export const fetchOutreachStatus = () =>
  CustomerAPI.get('/integrations/outreach/install_status/internal').then(
    (response) => response.data
  )

export const createAccessToken = (integrationName, body) => {
  return CustomerAPI.post(
    `/integrations/${integrationName}/access_token`,
    body
  ).then((response) => response.data)
}

export const createSlackbotToken = (code, href) => {
  const queryParams =
    href !== null ? encodeQueryData({ redirectUri: href }) : ''
  return CustomerAPI.post(`/integrations/slack/activate_bot?${queryParams}`, {
    code,
  }).then((response) => response.data)
}

export const updateIntegrationState = ({ integration, connected }) => {
  return CustomerAPI.patch('/integrations', { [integration]: connected }).then(
    (response) => response.data
  )
}

export const setWordpressDomain = (rootUrl) =>
  CustomerAPI.post('/integrations/wordpress/v2', { rootUrl })

export const fetchWordpressDomain = () =>
  CustomerAPI.get('/integrations/wordpress/v2').then(
    (response) => response.data
  )

export const getLeanDataAuthorizationStatus = () => {
  return ConversationAPI.get('/integration/test/leandata/authorization').then(
    (response) => response.data
  )
}

export const getIntegrationRetryDelay = (integration) => {
  return CustomerAPI.get(`/integrations/delay_time/${integration}`).then(
    (response) => response.data
  )
}
export const setIntegrationRetryDelay = (delay, integration) => {
  return CustomerAPI.post(
    `/integrations/delay_time/${integration}`,
    { retryDelayInMinutes: delay },
    {
      headers: { 'Content-Type': 'application/json' },
    }
  ).then((response) => response.data)
}
